import React, { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import ExclamationIcon from 'src/Assets/Svg/pages-icons/ExclamationPayment.svg?react'
import { FullScreenModal } from 'src/Components/FullScreenModal'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'

const SuccessBlock = styled.div`
  display: flex;
  max-width: 600px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 358px;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`
const ButtonBlock = styled.div`
  align-self: center;
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
  }
`

const StyledPrimaryButton = styled(PrimaryButton)`
  padding-left: 40px;
  padding-right: 40px;
`

interface ScheduleReelsModalProps {
  onTryTikTok: () => void
  onCloseModal: () => void
}

export const ScheduleReelsModal: FC<ScheduleReelsModalProps> = ({
  onTryTikTok,
  onCloseModal,
}) => (
  <FullScreenModal open>
    <Wrapper>
      <SuccessBlock>
        <ExclamationIcon width={40} height={40} />
        <Title>Reels creators are fully booked right now</Title>

        <Text>
          Good news — you can launch a TikTok campaign instead! Everything’s
          ready for this track, just one click to switch.
        </Text>

        <ButtonBlock>
          <PrimaryDottedButton onClick={onCloseModal}>
            Not now
          </PrimaryDottedButton>

          <StyledPrimaryButton onClick={onTryTikTok}>
            Try TikTok
          </StyledPrimaryButton>
        </ButtonBlock>
      </SuccessBlock>
    </Wrapper>
  </FullScreenModal>
)
